<template>
  <div class="gaolist">
    <Level1 :source="1"></Level1>
  </div>
</template>
<script>
import Level1 from "./modules/Level1.vue";
export default {
  name: "gaolist",
  components: {
    Level1,
  },
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss">
.gaolist{
    height: 100%;
}</style>
